import React, { Component, PureComponent, Fragment } from 'react'
import { Button, Table, Message } from 'semantic-ui-react'
import Modal from '~/common/modal'
import { Group } from '~/form'
import { isEmail } from 'validator'
import PeopleAddFromInputs from './addInputs'
import PeopleAddFromSheet from './addFromSheet'

let sources = [
  {
    value: 'inputs',
    title: 'Syötä käsin',
  },
  {
    value: 'sheet',
    title: 'Kopioi taulukko-ohjelmasta',
  },
]

export default class PeopleAdd extends Component {
  state = {
    values: [{}],
    rowErrors: {},
    source: 'inputs',
  }

  validate = values => {
    return values.reduce((errors, row, key) => {
      let rowErrors = {}

      if (!row[0]) rowErrors[0] = 'Nimi on pakollinen'

      // if (!isEmail(row[1] || ''))
      //   rowErrors[1] = 'Sähköposti on väärin'

      // if (!row[2])
      //   rowErrors[2] = 'Puhelin on pakollinen'

      if (Object.keys(rowErrors).length) errors[key] = rowErrors

      return errors
    }, {})
  }

  handleFullChange = (values, validate = false) => {
    if (!Array.isArray(values)) values = []

    this.setState({ values, rowErrors: validate ? this.validate(values) : {} })
  }

  handleCreate = () => {
    let { onCreate } = this.props
    let { values } = this.state

    let rowErrors = this.validate(values)

    if (Object.keys(rowErrors).length) return this.setState({ rowErrors })

    onCreate(
      values.map(r => ({
        email: r[1] || '',
        data: {
          name: r[0] || '',
          phone: r[2] || '',
          notes: r[3] || '',
        },
        lang: r[4] || 'fi',
      }))
    )

    this.setState({
      value: '',
      values: [],
      rowErrors: {},
    })
  }

  render() {
    let { open = false, loading = false, error = false, onClose } = this.props

    let { values = [], rowErrors = {}, source } = this.state
    let disabled = values.length === 0

    let actions = [
      <Button
        size="tiny"
        color="green"
        loading={loading}
        key="add"
        disabled={disabled}
        onClick={e => (e.preventDefault() & disabled ? false : this.handleCreate())}
        content="Lisää henkilöt"
        icon="save"
      />,
    ]

    return (
      <Modal open={open} onClose={onClose} actions={actions}>
        <div className="ui form">
          <div className="form-buttons" style={{ paddingBottom: 0 }}>
            {sources.map(({ value, title }) => (
              <button
                className={`button-plain ${value === source ? 'button--active' : ''}`}
                key={value}
                onClick={e => e.preventDefault() & this.setState({ source: value })}>
                {title}
              </button>
            ))}
          </div>
          {source === 'sheet' ? (
            <PeopleAddFromSheet values={values} onChange={this.handleFullChange} rowErrors={rowErrors} />
          ) : (
            <PeopleAddFromInputs values={values} onChange={this.handleFullChange} rowErrors={rowErrors} />
          )}
          {error ? <Message content={error} /> : null}
        </div>
      </Modal>
    )
  }
}
